import React from 'react'
import styles from './HeroCard.scss'
import {Card} from 'common/styleguide/Card'
import {Hero} from 'common/styleguide/Hero'

export class HeroCard extends React.PureComponent {
  render () {
    const {href, to, title, scrimOpacity, img, img2x, focalPoint, children} = this.props
    const heroProps = {scrimOpacity, img, img2x, focalPoint}
    return (
      <Card href={href} to={to} noPadding>
        <Hero small className={styles.hero} marginBottom='0' {...heroProps}>{title}</Hero>
        {children && <div className={styles.padded}>
          {children}
        </div>}
      </Card>
    )
  }
}
